module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "half"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("THE BATTLES FOR")]), _vm._v(" "), _c('p', {
    staticClass: "half1"
  }, [_vm._v("MONTE CASSINO")]), _vm._v(" "), _c('p', {
    staticClass: "half2"
  }, [_vm._v("THEN AND NOW")]), _vm._v(" "), _c('p', {
    staticClass: "hsub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What I saw took me back across 28 years,")])]), _vm._v(" "), _c('p', {
    staticClass: "hsub1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("when I experienced the same loneliness")])]), _vm._v(" "), _c('p', {
    staticClass: "hsub1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("crossing the battlefield of the Somme.")])]), _vm._v(" "), _c('p', {
    staticClass: "bkaut"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDOLIN VON SENGER UND ETTERLIN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5dc79b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Halftitle.vue
// module id = 57
// module chunks = 0